
import { ITreeNode } from '@circlon/angular-tree-component/lib/defs/api';
import { IGeographyNode } from '../interfaces/geography-node.interface';

export const COUNTRIES = [
    {
        projectCode: 'BPC2020',
        countryCode: 'AB',
        countryName: 'Albania',
        parent: '2B',
        order: 48
    },
    {
        countryCode: 'AA',
        countryName: 'Antigua and Barbuda',
        parent: '4B'
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'AC',
        countryName: 'Central African Republic',
        parent: '7B',
        order: 184
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'AF',
        countryName: 'Afghanistan',
        parent: '5B',
        order: 125
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'AG',
        countryName: 'Angola',
        parent: '7A',
        order: 155
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'AI',
        countryName: 'Anguilla',
        parent: '4B',
        order: 73
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'AJ',
        countryName: 'Azerbaijan',
        parent: '5A',
        order: 103
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'AL',
        countryName: 'Algeria',
        parent: '7A',
        order: 154
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'AM',
        countryName: 'Armenia',
        parent: '5B',
        order: 127
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'AO',
        countryName: 'Laos',
        parent: '5A',
        order: 112
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'AR',
        countryName: 'Argentina',
        parent: '4A',
        order: 56
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'AS',
        countryName: 'American Samoa',
        parent: '5B',
        order: 126
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'AT',
        countryName: 'Austria',
        parent: '1A',
        order: 2
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'AU',
        countryName: 'Australia',
        parent: '6A',
        order: 151
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'AZ',
        countryName: 'Aruba',
        parent: '4B',
        order: 75
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'BB',
        countryName: 'Barbados',
        parent: '4B',
        order: 77
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'BD',
        countryName: 'Bermuda',
        parent: '4B',
        order: 79
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'BE',
        countryName: 'Belgium',
        parent: '1A',
        order: 3
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'BF',
        countryName: 'Burkina Faso',
        parent: '7B',
        order: 181
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'BG',
        countryName: 'Bangladesh',
        parent: '5A',
        order: 104
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'BH',
        countryName: 'Bahrain',
        parent: '7B',
        order: 178
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'BI',
        countryName: 'Benin',
        parent: '7B',
        order: 179
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'BL',
        countryName: 'Belarus',
        parent: '2A',
        order: 29
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'BM',
        countryName: 'Bahamas',
        parent: '4B',
        order: 76
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'BN',
        countryName: 'Bhutan',
        parent: '5B',
        order: 128
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'BR',
        countryName: 'Brazil',
        parent: '4A',
        order: 58
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'BS',
        countryName: 'Bosnia and Herzegovina',
        parent: '2A',
        order: 30
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'BU',
        countryName: 'Bulgaria',
        parent: '2A',
        order: 31
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'BV',
        countryName: 'Bolivia',
        parent: '4A',
        order: 57
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'BZ',
        countryName: 'Belize',
        parent: '4B',
        order: 78
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'CA',
        countryName: 'Canada',
        parent: '3A',
        order: 53
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'CB',
        countryName: 'Cambodia',
        parent: '5A',
        order: 105
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'CC',
        countryName: 'Curaçao',
        parent: '4B',
        order: 83
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'CD',
        countryName: 'Chad',
        parent: '7B',
        order: 185
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'CG',
        countryName: 'Congo-Brazzaville',
        parent: '7B',
        order: 188
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'CH',
        countryName: 'Switzerland',
        parent: '1A',
        order: 16
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'CI',
        countryName: 'Cote d Ivoire',
        parent: '7A',
        order: 157
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'CL',
        countryName: 'Chile',
        parent: '4A',
        order: 59
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'CM',
        countryName: 'Cayman Islands',
        parent: '4B',
        order: 81
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'CN',
        countryName: 'China',
        parent: '5A',
        order: 107
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'CO',
        countryName: 'Colombia',
        parent: '4A',
        order: 60
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'CP',
        countryName: 'Sao Tomé e Príncipe',
        parent: '7B',
        order: 210
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'CR',
        countryName: 'Croatia',
        parent: '2A',
        order: 32
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'CS',
        countryName: 'Czech Republic',
        parent: '2A',
        order: 33
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'CU',
        countryName: 'Cuba',
        parent: '4B',
        order: 82
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'CV',
        countryName: 'Cabo Verde',
        parent: '7B',
        order: 183
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'CY',
        countryName: 'Cyprus',
        parent: '1B',
        order: 21
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'DE',
        countryName: 'Germany',
        parent: '1A',
        order: 7
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'DJ',
        countryName: 'Djibouti',
        parent: '7B',
        order: 189
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'DK',
        countryName: 'Denmark',
        parent: '1A',
        order: 4
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'DM',
        countryName: 'Dominica',
        parent: '4B',
        order: 84
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'DR',
        countryName: 'Dominican Republic',
        parent: '4A',
        order: 62
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'EC',
        countryName: 'Ecuador',
        parent: '4A',
        order: 63
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'EE',
        countryName: 'Eritrea',
        parent: '7B',
        order: 191
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'EG',
        countryName: 'Egypt',
        parent: '7A',
        order: 158
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'EI',
        countryName: 'Brunei Darussalam',
        parent: '5B',
        order: 129
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'EP',
        countryName: 'Ethiopia',
        parent: '7A',
        order: 159
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'EQ',
        countryName: 'Equatorial Guinea',
        parent: '7B',
        order: 190
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'ES',
        countryName: 'Spain',
        parent: '1A',
        order: 14
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'ET',
        countryName: 'Estonia',
        parent: '2A',
        order: 34
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'FG',
        countryName: 'French Guiana',
        parent: '4B',
        order: 85
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'FI',
        countryName: 'Finland',
        parent: '1A',
        order: 5
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'FJ',
        countryName: 'Fiji',
        parent: '5B',
        order: 130
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'FP',
        countryName: 'French Polynesia',
        parent: '5B',
        order: 131
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'FR',
        countryName: 'France',
        parent: '1A',
        order: 6
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'GB',
        countryName: 'United Kingdom',
        parent: '1A',
        order: 18
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'GC',
        countryName: 'Madagascar',
        parent: '7B',
        order: 200
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'GD',
        countryName: 'Grenada',
        parent: '4B',
        order: 86
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'GG',
        countryName: 'Georgia',
        parent: '2A',
        order: 35
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'GH',
        countryName: 'Ghana',
        parent: '7A',
        order: 160
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'GI',
        countryName: 'Gibraltar',
        parent: '1B',
        order: 22
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'GM',
        countryName: 'Guam',
        parent: '5B',
        order: 132
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'GO',
        countryName: 'Gabon',
        parent: '7B',
        order: 192
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'GP',
        countryName: 'Guadeloupe',
        parent: '4B',
        order: 87
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'GR',
        countryName: 'Greece',
        parent: '1A',
        order: 8
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'GT',
        countryName: 'Guatemala',
        parent: '4A',
        order: 65
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'GU',
        countryName: 'Guinea',
        parent: '7B',
        order: 194
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'GY',
        countryName: 'Guyana',
        parent: '4B',
        order: 88
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'HD',
        countryName: 'Honduras',
        parent: '4A',
        order: 66
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'HK',
        countryName: 'Hong Kong, China',
        parent: '5A',
        order: 108
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'HT',
        countryName: 'Haiti',
        parent: '4B',
        order: 89
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'HU',
        countryName: 'Hungary',
        parent: '2A',
        order: 36
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'IC',
        countryName: 'Iceland',
        parent: '1B',
        order: 23
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'ID',
        countryName: 'Indonesia',
        parent: '5A',
        order: 109
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'IE',
        countryName: 'Ireland',
        parent: '1A',
        order: 9
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'IN',
        countryName: 'India',
        parent: '5A',
        order: 106
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'IQ',
        countryName: 'Iraq',
        parent: '7A',
        order: 161
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'IR',
        countryName: 'Iran',
        parent: '7B',
        order: 196
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'IS',
        countryName: 'Israel',
        parent: '7A',
        order: 162
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'IT',
        countryName: 'Italy',
        parent: '1A',
        order: 10
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'JM',
        countryName: 'Jamaica',
        parent: '4B',
        order: 90
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'JO',
        countryName: 'Jordan',
        parent: '7A',
        order: 163
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'JP',
        countryName: 'Japan',
        parent: '5A',
        order: 110
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'KA',
        countryName: 'Sri Lanka',
        parent: '5A',
        order: 119
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'KB',
        countryName: 'Kiribati',
        parent: '5B',
        order: 133
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'KK',
        countryName: 'Kazakhstan',
        parent: '5A',
        order: 111
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'KR',
        countryName: 'South Korea',
        parent: '5A',
        order: 118
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'KS',
        countryName: 'Kosovo',
        parent: '2B',
        order: 49
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'KT',
        countryName: 'St Kitts and Nevis',
        parent: '4B',
        order: 95
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'KW',
        countryName: 'Kuwait',
        parent: '7A',
        order: 165
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'KY',
        countryName: 'Kenya',
        parent: '7A',
        order: 164
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'KZ',
        countryName: 'Kyrgyzstan',
        parent: '5B',
        order: 134
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'LA',
        countryName: 'Latvia',
        parent: '2A',
        order: 37
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'LB',
        countryName: 'Lebanon',
        parent: '7A',
        order: 166
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'LC',
        countryName: 'St Lucia',
        parent: '4B',
        order: 96
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'LE',
        countryName: 'Liberia',
        parent: '7B',
        order: 198
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'LI',
        countryName: 'Liechtenstein',
        parent: '1B',
        order: 24
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'LN',
        countryName: 'Sierra Leone',
        parent: '7B',
        order: 213
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'LO',
        countryName: 'Lesotho',
        parent: '7B',
        order: 197
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'LS',
        countryName: 'El Salvador',
        parent: '4A',
        order: 64
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'LT',
        countryName: 'Lithuania',
        parent: '2A',
        order: 38
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'LX',
        countryName: 'Luxembourg',
        parent: '1B',
        order: 25
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'LY',
        countryName: 'Libya',
        parent: '7B',
        order: 199
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'MA',
        countryName: 'Maldives',
        parent: '5B',
        order: 136
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'MB',
        countryName: 'Gambia',
        parent: '7B',
        order: 193
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'MD',
        countryName: 'North Macedonia',
        parent: '2A',
        order: 39
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'ME',
        countryName: 'Montenegro',
        parent: '2B',
        order: 51
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'MI',
        countryName: 'Mali',
        parent: '7B',
        order: 202
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'ML',
        countryName: 'Mongolia',
        parent: '5B',
        order: 137
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'MM',
        countryName: 'Mauritania',
        parent: '7B',
        order: 203
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'MN',
        countryName: 'Monaco',
        parent: '1B',
        order: 27
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'MO',
        countryName: 'Morocco',
        parent: '7A',
        order: 167
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'MQ',
        countryName: 'Martinique',
        parent: '4B',
        order: 91
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'MR',
        countryName: 'Myanmar',
        parent: '5A',
        order: 114
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'MS',
        countryName: 'Comoros',
        parent: '7B',
        order: 186
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'MT',
        countryName: 'Malta',
        parent: '1B',
        order: 26
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'MU',
        countryName: 'Macau, China',
        parent: '5B',
        order: 135
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'MV',
        countryName: 'Moldova',
        parent: '2B',
        order: 50
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'MW',
        countryName: 'Malawi',
        parent: '7B',
        order: 201
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'MX',
        countryName: 'Mexico',
        parent: '4A',
        order: 67
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'MY',
        countryName: 'Malaysia',
        parent: '5A',
        order: 113
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'NB',
        countryName: 'Namibia',
        parent: '7B',
        order: 206
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'NC',
        countryName: 'Nicaragua',
        parent: '4B',
        order: 92
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'NG',
        countryName: 'Nigeria',
        parent: '7A',
        order: 168
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'NK',
        countryName: 'North Korea',
        parent: '5B',
        order: 141
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'NL',
        countryName: 'Netherlands',
        parent: '1A',
        order: 11
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'NN',
        countryName: 'Niger',
        parent: '7B',
        order: 207
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'NO',
        countryName: 'Norway',
        parent: '1A',
        order: 12
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'NP',
        countryName: 'Nepal',
        parent: '5B',
        order: 139
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'NU',
        countryName: 'Nauru',
        parent: '5B',
        order: 138
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'NW',
        countryName: 'New Caledonia',
        parent: '5B',
        order: 140
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'NZ',
        countryName: 'New Zealand',
        parent: '6A',
        order: 152
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'OM',
        countryName: 'Oman',
        parent: '7A',
        order: 169
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'OO',
        countryName: 'Cameroon',
        parent: '7A',
        order: 156
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'PG',
        countryName: 'Paraguay',
        parent: '4A',
        order: 69
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'PH',
        countryName: 'Philippines',
        parent: '5A',
        order: 116
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'PK',
        countryName: 'Pakistan',
        parent: '5A',
        order: 115
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'PL',
        countryName: 'Poland',
        parent: '2A',
        order: 40
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'PM',
        countryName: 'Panama',
        parent: '4A',
        order: 68
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'PP',
        countryName: 'Papua New Guinea',
        parent: '5B',
        order: 142
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'PR',
        countryName: 'Puerto Rico',
        parent: '4B',
        order: 93
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'PT',
        countryName: 'Portugal',
        parent: '1A',
        order: 13
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'PU',
        countryName: 'Peru',
        parent: '4A',
        order: 70
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'QT',
        countryName: 'Qatar',
        parent: '7A',
        order: 170
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'RI',
        countryName: 'Costa Rica',
        parent: '4A',
        order: 61
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'RO',
        countryName: 'Romania',
        parent: '2A',
        order: 41
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'RR',
        countryName: 'Andorra',
        parent: '1B',
        order: 20
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'RS',
        countryName: 'Serbia',
        parent: '2A',
        order: 43
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'RU',
        countryName: 'Russia',
        parent: '2A',
        order: 42
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'RW',
        countryName: 'Rwanda',
        parent: '7B',
        order: 209
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'SA',
        countryName: 'Saudi Arabia',
        parent: '7A',
        order: 171
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'SD',
        countryName: 'Sudan',
        parent: '7B',
        order: 216
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'SE',
        countryName: 'Sweden',
        parent: '1A',
        order: 15
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'SG',
        countryName: 'Singapore',
        parent: '5A',
        order: 117
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'SI',
        countryName: 'Solomon Islands',
        parent: '5B',
        order: 144
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'SK',
        countryName: 'Slovakia',
        parent: '2A',
        order: 44
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'SL',
        countryName: 'Senegal',
        parent: '7B',
        order: 211
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'SM',
        countryName: 'Sint Maarten',
        parent: '4B',
        order: 94
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'SN',
        countryName: 'South Sudan',
        parent: '7B',
        order: 215
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'SO',
        countryName: 'Somalia',
        parent: '7B',
        order: 214
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'SS',
        countryName: 'Guinea-Bissau',
        parent: '7B',
        order: 195
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'SU',
        countryName: 'Suriname',
        parent: '4B',
        order: 98
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'SV',
        countryName: 'Slovenia',
        parent: '2A',
        order: 45
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'SW',
        countryName: 'Botswana',
        parent: '7B',
        order: 180
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'SY',
        countryName: 'Syria',
        parent: '7B',
        order: 218
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'SZ',
        countryName: 'Eswatini',
        parent: '7B',
        order: 217
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'TG',
        countryName: 'Tonga',
        parent: '5B',
        order: 146
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'TH',
        countryName: 'Thailand',
        parent: '5A',
        order: 121
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'TK',
        countryName: 'Tajikistan',
        parent: '5B',
        order: 145
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'TM',
        countryName: 'Turkmenistan',
        parent: '5B',
        order: 147
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'TO',
        countryName: 'Togo',
        parent: '7B',
        order: 219
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'TR',
        countryName: 'Turkey',
        parent: '1A',
        order: 17
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'TS',
        countryName: 'Mauritius',
        parent: '7B',
        order: 204
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'TT',
        countryName: 'Trinidad and Tobago',
        parent: '4B',
        order: 99
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'TU',
        countryName: 'Tunisia',
        parent: '7A',
        order: 174
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'TV',
        countryName: 'Tuvalu',
        parent: '5B',
        order: 148
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'TW',
        countryName: 'Taiwan',
        parent: '5A',
        order: 120
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'TZ',
        countryName: 'Tanzania',
        parent: '7A',
        order: 173
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'UA',
        countryName: 'United Arab Emirates',
        parent: '7A',
        order: 176
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'UG',
        countryName: 'Uganda',
        parent: '7A',
        order: 175
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'UK',
        countryName: 'Ukraine',
        parent: '2A',
        order: 46
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'UN',
        countryName: 'Réunion',
        parent: '7B',
        order: 208
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'US',
        countryName: 'US',
        parent: '3A',
        order: 54
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'UU',
        countryName: 'Burundi',
        parent: '7B',
        order: 182
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'UV',
        countryName: 'US Virgin Islands',
        parent: '4B',
        order: 100
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'UY',
        countryName: 'Uruguay',
        parent: '4A',
        order: 71
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'UZ',
        countryName: 'Uzbekistan',
        parent: '5A',
        order: 122
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'VE',
        countryName: 'Venezuela',
        parent: '4B',
        order: 101
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'VG',
        countryName: 'St Vincent and the Grenadines',
        parent: '4B',
        order: 97
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'VI',
        countryName: 'British Virgin Islands',
        parent: '4B',
        order: 80
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'VN',
        countryName: 'Vietnam',
        parent: '5A',
        order: 123
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'VT',
        countryName: 'Vanuatu',
        parent: '5B',
        order: 149
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'WO',
        countryName: 'World',
        parent: '',
        order: 0
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'WS',
        countryName: 'Samoa',
        parent: '5B',
        order: 143
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'YC',
        countryName: 'Seychelles',
        parent: '7B',
        order: 212
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'YE',
        countryName: 'Yemen',
        parent: '7B',
        order: 220
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'ZA',
        countryName: 'South Africa',
        parent: '7A',
        order: 172
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'ZB',
        countryName: 'Zambia',
        parent: '7B',
        order: 221
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'ZI',
        countryName: 'Congo, Democratic Republic',
        parent: '7B',
        order: 187
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'ZM',
        countryName: 'Mozambique',
        parent: '7B',
        order: 205
    },
    {
        projectCode: 'BPC2020',
        countryCode: 'ZW',
        countryName: 'Zimbabwe',
        parent: '7B',
        order: 222
    },
    {
        projectCode: 'BPC2020',
        countryCode: '1C',
        countryName: 'Other Western Europe Research',
        parent: '1B',
        order: 225
    }
];

export const COUNTRIES_DATA = {
    menuOption: {
        nodeCode: '1A',
        tierId: 0,
        typeId: 0,
        tierName: 'Countries',
        countryName: 'Countries',
        isSelected: true,
        title: 'Deselect all Countries'
    },
    menuOptionSelected: {
        nodeCode: '1A',
        tierId: 0,
        typeId: 0,
        tierName: 'countries',
        countryName: 'countries',
        isSelected: true,
        title: 'Deselect all countries'
    },
    treeNodes: [
        {
            geographyId: '1A',
            code: '1A',
            hierarchy: 'World/',
            isDisabled: false,
            isSelected: false,
            name: 'Western Europe',
            parent: 'WO',
            tierId: 0,
            typeId: 2,
            menuOptions: [
                {
                    nodeCode: '1A',
                    tierId: 0,
                    typeId: 0,
                    tierName: 'countries',
                    countryName: 'countries',
                    isSelected: false,
                    title: 'Select all countries'
                }
            ],
            children: [
                {
                    geographyId: 'AT',
                    code: 'AT',
                    hierarchy: 'World/ Western Europe/',
                    isDisabled: false,
                    isSelected: false,
                    menuOptions: [
                        {
                            nodeCode: '1A',
                            tierId: 5,
                            typeId: 15,
                            tierName: 'cities',
                            countryName: 'cities',
                            isSelected: false,
                            title: 'Select all cities'
                        }
                    ],
                    name: 'Austria',
                    parent: '1A',
                    tierId: 1,
                    typeId: 5,
                    children: [
                        {
                            geographyId: 'AT01',
                            code: 'AT01',
                            hierarchy: 'World/ Western Europe',
                            isDisabled: false,
                            isSelected: false,
                            menuOptions: [],
                            name: 'Vienna',
                            parent: 'AT',
                            tierId: 5,
                            typeId: 15,
                            children: []
                        }
                    ]
                },
                {
                    geographyId: 'BE',
                    code: 'BE',
                    hierarchy: 'World/ Western Europe',
                    isDisabled: false,
                    isSelected: false,
                    menuOptions: [
                        {
                            nodeCode: '1A',
                            tierId: 5,
                            typeId: 15,
                            tierName: 'cities',
                            countryName: 'cities',
                            isSelected: false,
                            title: 'Select all cities'
                        }
                    ],
                    name: 'Belgium',
                    parent: '1A',
                    tierId: 1,
                    typeId: 5,
                    children: [
                        {
                            geographyId: 'BE01',
                            code: 'BE01',
                            hierarchy: 'World/ Western Europe',
                            isDisabled: false,
                            isSelected: false,
                            menuOptions: [],
                            name: 'Antwerp',
                            parent: 'BE',
                            tierId: 5,
                            typeId: 15,
                            children: []
                        },
                        {
                            geographyId: 'BE02',
                            code: 'BE02',
                            hierarchy: 'World/ Western Europe',
                            isDisabled: false,
                            isSelected: false,
                            menuOptions: [],
                            name: 'Brussels',
                            parent: 'BE',
                            tierId: 5,
                            typeId: 15,
                            children: []
                        }
                    ]
                }
            ]
        }
    ] as Array<IGeographyNode>,
    treeNodesSelected: [
        {
            geographyId: '1A',
            code: '1A',
            hierarchy: 'World/',
            isDisabled: false,
            isSelected: false,
            name: 'Western Europe',
            parent: 'WO',
            tierId: 0,
            typeId: 2,
            menuOptions: [
                {
                    nodeCode: '1A',
                    tierId: 0,
                    typeId: 0,
                    tierName: 'countries',
                    countryName: 'countries',
                    isSelected: true,
                    title: 'Deselect all countries'
                }
            ],
            children: [
                {
                    geographyId: 'AT',
                    code: 'AT',
                    hierarchy: 'World/ Western Europe/',
                    isDisabled: false,
                    isSelected: true,
                    menuOptions: [
                        {
                            nodeCode: '1A',
                            tierId: 5,
                            typeId: 15,
                            tierName: 'cities',
                            countryName: 'cities',
                            isSelected: false,
                            title: 'Select all cities'
                        }
                    ],
                    name: 'Austria',
                    parent: '1A',
                    tierId: 1,
                    typeId: 5,
                    children: [
                        {
                            geographyId: 'AT01',
                            code: 'AT01',
                            hierarchy: 'World/ Western Europe',
                            isDisabled: false,
                            isSelected: false,
                            menuOptions: [],
                            name: 'Vienna',
                            parent: 'AT',
                            tierId: 5,
                            typeId: 15,
                            children: []
                        }
                    ]
                },
                {
                    geographyId: 'BE',
                    code: 'BE',
                    hierarchy: 'World/ Western Europe',
                    isDisabled: false,
                    isSelected: true,
                    menuOptions: [
                        {
                            nodeCode: '1A',
                            tierId: 5,
                            typeId: 15,
                            tierName: 'cities',
                            countryName: 'cities',
                            isSelected: false,
                            title: 'Select all cities'
                        }
                    ],
                    name: 'Belgium',
                    parent: '1A',
                    tierId: 1,
                    typeId: 5,
                    children: [
                        {
                            geographyId: 'BE01',
                            code: 'BE01',
                            hierarchy: 'World/ Western Europe',
                            isDisabled: false,
                            isSelected: false,
                            menuOptions: [],
                            name: 'Antwerp',
                            parent: 'BE',
                            tierId: 5,
                            typeId: 15,
                            children: []
                        },
                        {
                            geographyId: 'BE02',
                            code: 'BE02',
                            hierarchy: 'World/ Western Europe',
                            isDisabled: false,
                            isSelected: false,
                            menuOptions: [],
                            name: 'Brussels',
                            parent: 'BE',
                            tierId: 5,
                            typeId: 15,
                            children: []
                        }
                    ]
                }
            ]
        }
    ] as Array<IGeographyNode>,
    deSelectedNode: {
        data: {
            code: '1A',
            name: 'Western Europe',
            parent: 'WO',
            isSelected: false,
            typeId: 2,
            tierId: 0,
            menuOptions: [
                {
                    nodeCode: '1A',
                    tierId: 0,
                    typeId: 0,
                    tierName: 'Countries',
                    countryName: 'Countries',
                    isSelected: true,
                    title: 'Deselect all Countries'
                },
                {
                    nodeCode: '1A',
                    tierId: 1,
                    typeId: 5,
                    tierName: 'Tier 1 (Non-core country)',
                    countryName: 'Tier 1 (Non-core country)',
                    isSelected: true,
                    title: 'Deselect all Tier 1 (Non-core country)'
                },
                {
                    nodeCode: '1A',
                    tierId: 0,
                    typeId: 3,
                    tierName: 'Other region',
                    countryName: 'Other region',
                    isSelected: true,
                    title: 'Deselect all Other region'
                },
                {
                    nodeCode: '1A',
                    tierId: 4,
                    typeId: 6,
                    tierName: 'Modelled country',
                    countryName: 'Modelled country',
                    isSelected: true,
                    title: 'Deselect all Modelled country'
                },
                {
                    nodeCode: '1A',
                    tierId: 5,
                    typeId: 15,
                    tierName: 'Cities',
                    countryName: 'Cities',
                    isSelected: false,
                    title: 'Select all  Cities'
                },
                {
                    nodeCode: '1A',
                    tierId: 2,
                    typeId: 37,
                    tierName: 'Market Insight (Research)',
                    countryName: 'Market Insight (Research)',
                    isSelected: true,
                    title: 'Deselect all Market Insight (Research)'
                }
            ],
            hierarchy: 'World/',
            children: [
                // ... (unchanged)
            ],
            emiCode: 3374617444086
        },
        children: [],
        displayField: '',
        elementRef: undefined,
        hasChildren: false,
        id: undefined,
        index: 0,
        isActive: false,
        isCollapsed: false,
        isExpanded: false,
        isFocused: false,
        isLeaf: false,
        isRoot: false,
        level: 0,
        parent: undefined as ITreeNode | undefined,
        path: [],
        blur(): any {},
        collapse(): any {},
        collapseAll(): any {},
        doForAll(fn: (nodes: ITreeNode) => any): any {},
        ensureVisible(): any {},
        expand(): any {},
        expandAll(): any {},
        findNextNode(goInside: boolean): ITreeNode | undefined {
            return undefined;
        },
        findNextSibling(skipHidden: any): ITreeNode | undefined {
            return undefined;
        },
        findPreviousNode(skipHidden: any): ITreeNode | undefined {
            return undefined;
        },
        findPreviousSibling(skipHidden: any): ITreeNode | undefined {
            return undefined;
        },
        fireEvent(event: any): any {},
        focus(): any {},
        getClass(): string {
            return '';
        },
        getFirstChild(skipHidden: any): ITreeNode | undefined {
            return undefined;
        },
        getLastChild(skipHidden: any): ITreeNode | undefined {
            return undefined;
        },
        getNodePadding(): string {
            return '';
        },
        hide(): any {},
        isDescendantOf(nodes: ITreeNode): boolean {
            return false;
        },
        scrollIntoView(): any {},
        setActiveAndVisible(multi: boolean): any {},
        setIsActive(value: boolean, multi?: boolean): any {},
        setIsHidden(value: boolean): any {},
        show(): any {},
        toggleActivated(multi: any): any {},
        toggleExpanded(): any {}
    } as unknown as ITreeNode,
    selectedNode: {
        data: {
            code: '1A',
            name: 'Western Europe',
            parent: 'WO',
            isSelected: false,
            isDisabled: false,
            typeId: 2,
            tierId: 0,
            menuOptions: [
                {
                    nodeCode: '1A',
                    tierId: 0,
                    typeId: 3,
                    tierName: 'Other region',
                    countryName: 'Other region',
                    isSelected: false,
                    title: 'Select all Other region'
                },
                {
                    nodeCode: '1A',
                    tierId: 1,
                    typeId: 5,
                    tierName: 'Tier 1 (Non-core country)',
                    countryName: 'Tier 1 (Non-core country)',
                    isSelected: false,
                    title: 'Select all Tier 1 (Non-core country)'
                },
                {
                    nodeCode: '1A',
                    tierId: 4,
                    typeId: 6,
                    tierName: 'Modelled country',
                    countryName: 'Modelled country',
                    isSelected: false,
                    title: 'Select all Modelled country'
                },
                {
                    nodeCode: '1A',
                    tierId: 5,
                    typeId: 15,
                    tierName: 'Countries',
                    countryName: 'Countries',
                    isSelected: false,
                    title: 'Select all countries'
                },
                {
                    nodeCode: '1A',
                    tierId: 5,
                    typeId: 15,
                    tierName: 'Cities',
                    countryName: 'Cities',
                    isSelected: false,
                    title: 'Select all cities'
                },
                {
                    nodeCode: '1A',
                    tierId: 2,
                    typeId: 37,
                    tierName: 'Market Insight (Research)',
                    countryName: 'Market Insight (Research)',
                    isSelected: false,
                    title: 'Select all Market Insight (Research)'
                }
            ],
            hierarchy: 'World/',
            children: [
                {
                    code: 'AT',
                    name: 'Austria',
                    parent: '1A',
                    isSelected: false,
                    isDisabled: false,
                    typeId: 5,
                    tierId: 1,
                    menuOptions: [
                        {
                            nodeCode: 'AT',
                            tierId: 5,
                            typeId: 15,
                            tierName: 'Cities',
                            countryName: 'Cities',
                            isSelected: false,
                            title: 'Select all cities'
                        }
                    ],
                    hierarchy: 'World/ Western Europe/',
                    children: [
                        {
                            code: 'AT01',
                            name: 'Vienna',
                            parent: 'AT',
                            isSelected: false,
                            isDisabled: true,
                            typeId: 15,
                            tierId: 5,
                            menuOptions: [],
                            hierarchy: 'World/ Western Europe/ Austria/',
                            children: []
                        }
                    ]
                },
                {
                    code: 'BE',
                    name: 'Belgium',
                    parent: '1A',
                    isSelected: false,
                    isDisabled: false,
                    typeId: 5,
                    tierId: 1,
                    menuOptions: [
                        {
                            nodeCode: 'BE',
                            tierId: 5,
                            typeId: 15,
                            tierName: 'Cities',
                            countryName: 'Cities',
                            isSelected: false,
                            title: 'Select all cities'
                        }
                    ],
                    hierarchy: 'World/ Western Europe/',
                    children: [
                        {
                            code: 'BE01',
                            name: 'Antwerp',
                            parent: 'BE',
                            isSelected: false,
                            isDisabled: true,
                            typeId: 15,
                            tierId: 5,
                            menuOptions: [],
                            hierarchy: 'World/ Western Europe/ Belgium/',
                            children: []
                        },
                        {
                            code: 'BE02',
                            name: 'Brussels',
                            parent: 'BE',
                            isSelected: false,
                            isDisabled: true,
                            typeId: 15,
                            tierId: 5,
                            menuOptions: [],
                            hierarchy: 'World/ Western Europe/ Belgium/',
                            children: []
                        }
                    ]
                }
            ]
        },
        children: [],
        displayField: '',
        elementRef: undefined,
        hasChildren: false,
        id: undefined,
        index: 0,
        isActive: false,
        isCollapsed: false,
        isExpanded: false,
        isFocused: false,
        isLeaf: false,
        isRoot: false,
        level: 0,
        parent: undefined as ITreeNode | undefined,
        path: [],
        blur(): any {},
        collapse(): any {},
        collapseAll(): any {},
        doForAll(_fn: (nodes: ITreeNode) => any): any {},
        ensureVisible(): any {},
        expand(): any {},
        expandAll(): any {},
        findNextNode(goInside: boolean): ITreeNode | undefined {
            return undefined;
        },
        findNextSibling(skipHidden: any): ITreeNode | undefined {
            return undefined;
        },
        findPreviousNode(skipHidden: any): ITreeNode | undefined {
            return undefined;
        },
        findPreviousSibling(skipHidden: any): ITreeNode | undefined {
            return undefined;
        },
        fireEvent(event: any): any {},
        focus(): any {},
        getClass(): string {
            return '';
        },
        getFirstChild(skipHidden: any): ITreeNode | undefined {
            return undefined;
        },
        getLastChild(skipHidden: any): ITreeNode | undefined {
            return undefined;
        },
        getNodePadding(): string {
            return '';
        },
        hide(): any {},
        isDescendantOf(nodes: ITreeNode): boolean {
            return false;
        },
        scrollIntoView(): any {},
        setActiveAndVisible(multi: boolean): any {},
        setIsActive(value: boolean, multi?: boolean): any {},
        setIsHidden(value: boolean): any {},
        show(): any {},
        toggleActivated(multi: any): any {},
        toggleExpanded(): any {}
    } as unknown as ITreeNode,
    expectedData: {
        code: '1A',
        name: 'Western Europe',
        parent: 'WO',
        isSelected: false,
        typeId: 2,
        tierId: 0,
        menuOptions: [
            {
                nodeCode: '1A',
                tierId: 0,
                typeId: 0,
                tierName: 'Countries',
                countryName: 'Countries',
                isSelected: true,
                title: 'Deselect all Countries'
            },
            {
                nodeCode: '1A',
                tierId: 1,
                typeId: 5,
                tierName: 'Tier 1 (Non-core country)',
                countryName: 'Tier 1 (Non-core country)',
                isSelected: true,
                title: 'Deselect all Tier 1 (Non-core country)'
            },
            {
                nodeCode: '1A',
                tierId: 0,
                typeId: 3,
                tierName: 'Other region',
                countryName: 'Other region',
                isSelected: true,
                title: 'Deselect all Other region'
            },
            {
                nodeCode: '1A',
                tierId: 4,
                typeId: 6,
                tierName: 'Modelled country',
                countryName: 'Modelled country',
                isSelected: true,
                title: 'Deselect all Modelled country'
            },
            {
                nodeCode: '1A',
                tierId: 5,
                typeId: 15,
                tierName: 'Cities',
                countryName: 'Cities',
                isSelected: false,
                title: 'Select all  Cities'
            },
            {
                nodeCode: '1A',
                tierId: 2,
                typeId: 37,
                tierName: 'Market Insight (Research)',
                countryName: 'Market Insight (Research)',
                isSelected: true,
                title: 'Deselect all Market Insight (Research)'
            }
        ],
        hierarchy: 'World/',
        children: [
            {
                code: 'AT',
                name: 'Austria',
                parent: '1A',
                isSelected: true,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'AT',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'AT01',
                        name: 'Vienna',
                        parent: 'AT',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Austria/',
                        children: [],
                        emiCode: 9850515031359
                    }
                ],
                emiCode: 6248419488286
            },
            {
                code: 'BE',
                name: 'Belgium',
                parent: '1A',
                isSelected: true,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'BE',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'BE01',
                        name: 'Antwerp',
                        parent: 'BE',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Belgium/',
                        children: [],
                        emiCode: 9308390977459
                    },
                    {
                        code: 'BE02',
                        name: 'Brussels',
                        parent: 'BE',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Belgium/',
                        children: [],
                        emiCode: 8155632473945
                    }
                ],
                emiCode: 3718782947010
            },
            {
                code: 'DK',
                name: 'Denmark',
                parent: '1A',
                isSelected: true,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'DK',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'DK01',
                        name: 'Copenhagen',
                        parent: 'DK',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Denmark/',
                        children: [],
                        emiCode: 485261642245
                    }
                ],
                emiCode: 1427102210201
            },
            {
                code: 'FI',
                name: 'Finland',
                parent: '1A',
                isSelected: true,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'FI',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'FI01',
                        name: 'Helsinki',
                        parent: 'FI',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Finland/',
                        children: [],
                        emiCode: 182528628580
                    }
                ],
                emiCode: 791670366320
            },
            {
                code: 'FR',
                name: 'France',
                parent: '1A',
                isSelected: true,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'FR',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'FR03',
                        name: 'Lyon',
                        parent: 'FR',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ France/',
                        children: [],
                        emiCode: 1254681573221
                    },
                    {
                        code: 'FR02',
                        name: 'Marseille',
                        parent: 'FR',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ France/',
                        children: [],
                        emiCode: 2046998743803
                    },
                    {
                        code: 'FR01',
                        name: 'Paris',
                        parent: 'FR',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ France/',
                        children: [],
                        emiCode: 3860242919398
                    }
                ],
                emiCode: 801272412850
            },
            {
                code: 'DE',
                name: 'Germany',
                parent: '1A',
                isSelected: true,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'DE',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'DE01',
                        name: 'Berlin',
                        parent: 'DE',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Germany/',
                        children: [],
                        emiCode: 2055241488420
                    },
                    {
                        code: 'DE02',
                        name: 'Hamburg',
                        parent: 'DE',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Germany/',
                        children: [],
                        emiCode: 7801287330450
                    },
                    {
                        code: 'DE05',
                        name: 'Frankfurt am Main',
                        parent: 'DE',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Germany/',
                        children: [],
                        emiCode: 7526396752932
                    },
                    {
                        code: 'DE03',
                        name: 'Munich',
                        parent: 'DE',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Germany/',
                        children: [],
                        emiCode: 8768676404726
                    },
                    {
                        code: 'DE04',
                        name: 'Cologne',
                        parent: 'DE',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Germany/',
                        children: [],
                        emiCode: 7375696431988
                    }
                ],
                emiCode: 8228655476453
            },
            {
                code: 'GR',
                name: 'Greece',
                parent: '1A',
                isSelected: true,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'GR',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'GR01',
                        name: 'Athens',
                        parent: 'GR',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Greece/',
                        children: [],
                        emiCode: 7599343601398
                    }
                ],
                emiCode: 534375091174
            },
            {
                code: 'IE',
                name: 'Ireland',
                parent: '1A',
                isSelected: true,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'IE',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'IE01',
                        name: 'Dublin',
                        parent: 'IE',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Ireland/',
                        children: [],
                        emiCode: 9177954134649
                    }
                ],
                emiCode: 8549761874506
            },
            {
                code: 'IT',
                name: 'Italy',
                parent: '1A',
                isSelected: true,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'IT',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'IT02',
                        name: 'Milan',
                        parent: 'IT',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Italy/',
                        children: [],
                        emiCode: 7086934954014
                    },
                    {
                        code: 'IT01',
                        name: 'Rome',
                        parent: 'IT',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Italy/',
                        children: [],
                        emiCode: 5396209415076
                    }
                ],
                emiCode: 7003471271071
            },
            {
                code: 'NL',
                name: 'Netherlands',
                parent: '1A',
                isSelected: true,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'NL',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'NL01',
                        name: 'Amsterdam',
                        parent: 'NL',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Netherlands/',
                        children: [],
                        emiCode: 87804787712
                    },
                    {
                        code: 'NL02',
                        name: 'Rotterdam',
                        parent: 'NL',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Netherlands/',
                        children: [],
                        emiCode: 2456080067527
                    }
                ],
                emiCode: 4631156072843
            },
            {
                code: 'NO',
                name: 'Norway',
                parent: '1A',
                isSelected: true,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'NO',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'NO01',
                        name: 'Oslo',
                        parent: 'NO',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Norway/',
                        children: [],
                        emiCode: 82317540879
                    }
                ],
                emiCode: 653567291646
            },
            {
                code: 'PT',
                name: 'Portugal',
                parent: '1A',
                isSelected: true,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'PT',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'PT01',
                        name: 'Lisbon',
                        parent: 'PT',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Portugal/',
                        children: [],
                        emiCode: 7151005922681
                    }
                ],
                emiCode: 2250000439705
            },
            {
                code: 'ES',
                name: 'Spain',
                parent: '1A',
                isSelected: true,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'ES',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'ES02',
                        name: 'Barcelona',
                        parent: 'ES',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Spain/',
                        children: [],
                        emiCode: 4673191263527
                    },
                    {
                        code: 'ES01',
                        name: 'Madrid',
                        parent: 'ES',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Spain/',
                        children: [],
                        emiCode: 2355090963672
                    }
                ],
                emiCode: 2131222151331
            },
            {
                code: 'SE',
                name: 'Sweden',
                parent: '1A',
                isSelected: true,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'SE',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'SE02',
                        name: 'Gothenburg',
                        parent: 'SE',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Sweden/',
                        children: [],
                        emiCode: 2331898734173
                    },
                    {
                        code: 'SE01',
                        name: 'Stockholm',
                        parent: 'SE',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Sweden/',
                        children: [],
                        emiCode: 677471594377
                    }
                ],
                emiCode: 4685492795444
            },
            {
                code: 'CH',
                name: 'Switzerland',
                parent: '1A',
                isSelected: true,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'CH',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'CH02',
                        name: 'Geneva',
                        parent: 'CH',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Switzerland/',
                        children: [],
                        emiCode: 1763218396014
                    },
                    {
                        code: 'CH01',
                        name: 'Zurich',
                        parent: 'CH',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Switzerland/',
                        children: [],
                        emiCode: 8935258680680
                    }
                ],
                emiCode: 9653420288905
            },
            {
                code: 'TR',
                name: 'Turkey',
                parent: '1A',
                isSelected: true,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'TR',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'TR02',
                        name: 'Ankara',
                        parent: 'TR',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Turkey/',
                        children: [],
                        emiCode: 5665931845217
                    },
                    {
                        code: 'TR01',
                        name: 'Istanbul',
                        parent: 'TR',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Turkey/',
                        children: [],
                        emiCode: 7319118088136
                    }
                ],
                emiCode: 4195282026105
            },
            {
                code: 'GB',
                name: 'United Kingdom',
                parent: '1A',
                isSelected: true,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'GB',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'GB04',
                        name: 'Birmingham',
                        parent: 'GB',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ United Kingdom/',
                        children: [],
                        emiCode: 4816656246000
                    },
                    {
                        code: 'GB01',
                        name: 'Glasgow',
                        parent: 'GB',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ United Kingdom/',
                        children: [],
                        emiCode: 4040065708465
                    },
                    {
                        code: 'GB02',
                        name: 'Leeds',
                        parent: 'GB',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ United Kingdom/',
                        children: [],
                        emiCode: 8228873976226
                    },
                    {
                        code: 'GB03',
                        name: 'London',
                        parent: 'GB',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ United Kingdom/',
                        children: [],
                        emiCode: 7155125154818
                    },
                    {
                        code: 'GB05',
                        name: 'Manchester',
                        parent: 'GB',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ United Kingdom/',
                        children: [],
                        emiCode: 4821442509684
                    }
                ],
                emiCode: 8620767550960
            },
            {
                code: '1B',
                name: 'Other Western Europe',
                parent: '1A',
                isSelected: false,
                typeId: 3,
                tierId: 0,
                menuOptions: [
                    {
                        nodeCode: '1B',
                        tierId: 0,
                        typeId: 0,
                        tierName: 'Countries',
                        countryName: 'Countries',
                        isSelected: true,
                        title: 'Deselect all Countries'
                    },
                    {
                        nodeCode: '1B',
                        tierId: 4,
                        typeId: 6,
                        tierName: 'Modelled country',
                        countryName: 'Modelled country',
                        isSelected: false,
                        title: 'Select all  Modelled country'
                    },
                    {
                        nodeCode: '1B',
                        tierId: 2,
                        typeId: 37,
                        tierName: 'Market Insight (Research)',
                        countryName: 'Market Insight (Research)',
                        isSelected: false,
                        title: 'Select all  Market Insight (Research)'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'RR',
                        name: 'Andorra',
                        parent: '1B',
                        isSelected: true,
                        typeId: 6,
                        tierId: 4,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Other Western Europe/',
                        children: [],
                        emiCode: 8044617045983
                    },
                    {
                        code: 'CY',
                        name: 'Cyprus',
                        parent: '1B',
                        isSelected: true,
                        typeId: 37,
                        tierId: 2,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Other Western Europe/',
                        children: [],
                        emiCode: 5261999488751
                    },
                    {
                        code: 'GI',
                        name: 'Gibraltar',
                        parent: '1B',
                        isSelected: true,
                        typeId: 6,
                        tierId: 4,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Other Western Europe/',
                        children: [],
                        emiCode: 3979070403604
                    },
                    {
                        code: 'IC',
                        name: 'Iceland',
                        parent: '1B',
                        isSelected: true,
                        typeId: 37,
                        tierId: 2,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Other Western Europe/',
                        children: [],
                        emiCode: 581644687546
                    },
                    {
                        code: 'LI',
                        name: 'Liechtenstein',
                        parent: '1B',
                        isSelected: true,
                        typeId: 6,
                        tierId: 4,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Other Western Europe/',
                        children: [],
                        emiCode: 9839603383334
                    },
                    {
                        code: 'LX',
                        name: 'Luxembourg',
                        parent: '1B',
                        isSelected: true,
                        typeId: 6,
                        tierId: 4,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Other Western Europe/',
                        children: [],
                        emiCode: 5360280853898
                    },
                    {
                        code: 'MT',
                        name: 'Malta',
                        parent: '1B',
                        isSelected: true,
                        typeId: 37,
                        tierId: 2,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Other Western Europe/',
                        children: [],
                        emiCode: 4758429578743
                    },
                    {
                        code: 'MN',
                        name: 'Monaco',
                        parent: '1B',
                        isSelected: true,
                        typeId: 6,
                        tierId: 4,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Other Western Europe/',
                        children: [],
                        emiCode: 7184599968704
                    }
                ],
                emiCode: 3224770570152
            }
        ],
        emiCode: 5340255542331
    },
    expectedDataAfterDeselect: [
        {
        geographyId: '1A',
        code: '1A',
        hierarchy: 'World/',
        isDisabled: false,
        isSelected: false,
        name: 'Western Europe',
        parent: 'WO',
        tierId: 0,
        typeId: 2,
        menuOptions: [],
        children: [
            {
                geographyId: 'AT',
                code: 'AT',
                hierarchy: 'World/ Western Europe/',
                isDisabled: false,
                isSelected: false,
                menuOptions: [
                    {
                        nodeCode: '1A',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all cities'
                    }
                ],
                name: 'Austria',
                parent: '1A',
                tierId: 1,
                typeId: 5,
                children: [
                    {
                        geographyId: 'AT01',
                        code: 'AT01',
                        hierarchy: 'World/ Western Europe',
                        isDisabled: false,
                        isSelected: true,
                        menuOptions: [],
                        name: 'Vienna',
                        parent: 'AT',
                        tierId: 5,
                        typeId: 15,
                        children: []
                    }
                ]
            },
            {
                geographyId: 'BE',
                code: 'BE',
                hierarchy: 'World/ Western Europe',
                isDisabled: false,
                isSelected: false,
                menuOptions: [
                    {
                        nodeCode: '1A',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all cities'
                    }
                ],
                name: 'Belgium',
                parent: '1A',
                tierId: 1,
                typeId: 5,
                children: [
                    {
                        geographyId: 'BE01',
                        code: 'BE01',
                        hierarchy: 'World/ Western Europe',
                        isDisabled: false,
                        isSelected: true,
                        menuOptions: [],
                        name: 'Antwerp',
                        parent: 'BE',
                        tierId: 5,
                        typeId: 15,
                        children: []
                    },
                    {
                        geographyId: 'BE02',
                        code: 'BE02',
                        hierarchy: 'World/ Western Europe',
                        isDisabled: false,
                        isSelected: true,
                        menuOptions: [],
                        name: 'Brussels',
                        parent: 'BE',
                        tierId: 5,
                        typeId: 15,
                        children: []
                    }
                ]
            }
        ]
    }
    ] as Array<IGeographyNode>,
    selectedCountriesNode: {
        code: '1A',
        name: 'Western Europe',
        parent: 'WO',
        isSelected: false,
        typeId: 2,
        tierId: 0,
        menuOptions: [
            {
                nodeCode: '1A',
                tierId: 0,
                typeId: 0,
                tierName: 'Countries',
                countryName: 'Countries',
                isSelected: false,
                title: 'Select all Countries'
            },
            {
                nodeCode: '1A',
                tierId: 1,
                typeId: 5,
                tierName: 'Tier 1 (Non-core country)',
                countryName: 'Tier 1 (Non-core country)',
                isSelected: false,
                title: 'Select all Tier 1 (Non-core country)'
            },
            {
                nodeCode: '1A',
                tierId: 0,
                typeId: 3,
                tierName: 'Other region',
                countryName: 'Other region',
                isSelected: false,
                title: 'Select all Other region'
            },
            {
                nodeCode: '1A',
                tierId: 4,
                typeId: 6,
                tierName: 'Modelled country',
                countryName: 'Modelled country',
                isSelected: false,
                title: 'Select all Modelled country'
            },
            {
                nodeCode: '1A',
                tierId: 5,
                typeId: 15,
                tierName: 'Cities',
                countryName: 'Cities',
                isSelected: false,
                title: 'Select all  Cities'
            },
            {
                nodeCode: '1A',
                tierId: 2,
                typeId: 37,
                tierName: 'Market Insight (Research)',
                countryName: 'Market Insight (Research)',
                isSelected: false,
                title: 'Select all Market Insight (Research)'
            }
        ],
        hierarchy: 'World/',
        children: [
            {
                code: 'AT',
                name: 'Austria',
                parent: '1A',
                isSelected: false,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'AT',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'AT01',
                        name: 'Vienna',
                        parent: 'AT',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Austria/',
                        children: [],
                        emiCode: 1307042783643
                    }
                ],
                emiCode: 96722767554
            },
            {
                code: 'BE',
                name: 'Belgium',
                parent: '1A',
                isSelected: false,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'BE',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'BE01',
                        name: 'Antwerp',
                        parent: 'BE',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Belgium/',
                        children: [],
                        emiCode: 9411364844996
                    },
                    {
                        code: 'BE02',
                        name: 'Brussels',
                        parent: 'BE',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Belgium/',
                        children: [],
                        emiCode: 1406196395215
                    }
                ],
                emiCode: 8569977248118
            },
            {
                code: 'DK',
                name: 'Denmark',
                parent: '1A',
                isSelected: false,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'DK',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'DK01',
                        name: 'Copenhagen',
                        parent: 'DK',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Denmark/',
                        children: [],
                        emiCode: 1336397279996
                    }
                ],
                emiCode: 2942440026709
            },
            {
                code: 'FI',
                name: 'Finland',
                parent: '1A',
                isSelected: false,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'FI',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'FI01',
                        name: 'Helsinki',
                        parent: 'FI',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Finland/',
                        children: [],
                        emiCode: 6188440840632
                    }
                ],
                emiCode: 8260064991495
            },
            {
                code: 'FR',
                name: 'France',
                parent: '1A',
                isSelected: false,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'FR',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'FR03',
                        name: 'Lyon',
                        parent: 'FR',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ France/',
                        children: [],
                        emiCode: 1145830782762
                    },
                    {
                        code: 'FR02',
                        name: 'Marseille',
                        parent: 'FR',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ France/',
                        children: [],
                        emiCode: 2071581098917
                    },
                    {
                        code: 'FR01',
                        name: 'Paris',
                        parent: 'FR',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ France/',
                        children: [],
                        emiCode: 7209093052962
                    }
                ],
                emiCode: 227967839739
            },
            {
                code: 'DE',
                name: 'Germany',
                parent: '1A',
                isSelected: false,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'DE',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'DE01',
                        name: 'Berlin',
                        parent: 'DE',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Germany/',
                        children: [],
                        emiCode: 3384896199266
                    },
                    {
                        code: 'DE02',
                        name: 'Hamburg',
                        parent: 'DE',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Germany/',
                        children: [],
                        emiCode: 4141319288284
                    },
                    {
                        code: 'DE05',
                        name: 'Frankfurt am Main',
                        parent: 'DE',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Germany/',
                        children: [],
                        emiCode: 7290192274428
                    },
                    {
                        code: 'DE03',
                        name: 'Munich',
                        parent: 'DE',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Germany/',
                        children: [],
                        emiCode: 9171701941783
                    },
                    {
                        code: 'DE04',
                        name: 'Cologne',
                        parent: 'DE',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Germany/',
                        children: [],
                        emiCode: 2022585140906
                    }
                ],
                emiCode: 3355384880565
            },
            {
                code: 'GR',
                name: 'Greece',
                parent: '1A',
                isSelected: false,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'GR',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'GR01',
                        name: 'Athens',
                        parent: 'GR',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Greece/',
                        children: [],
                        emiCode: 7200517880692
                    }
                ],
                emiCode: 7305547455495
            },
            {
                code: 'IE',
                name: 'Ireland',
                parent: '1A',
                isSelected: false,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'IE',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'IE01',
                        name: 'Dublin',
                        parent: 'IE',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Ireland/',
                        children: [],
                        emiCode: 3007288435598
                    }
                ],
                emiCode: 5886079771443
            },
            {
                code: 'IT',
                name: 'Italy',
                parent: '1A',
                isSelected: false,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'IT',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'IT02',
                        name: 'Milan',
                        parent: 'IT',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Italy/',
                        children: [],
                        emiCode: 6931276955795
                    },
                    {
                        code: 'IT01',
                        name: 'Rome',
                        parent: 'IT',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Italy/',
                        children: [],
                        emiCode: 63891137942
                    }
                ],
                emiCode: 4598387106744
            },
            {
                code: 'NL',
                name: 'Netherlands',
                parent: '1A',
                isSelected: false,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'NL',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'NL01',
                        name: 'Amsterdam',
                        parent: 'NL',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Netherlands/',
                        children: [],
                        emiCode: 321811575494
                    },
                    {
                        code: 'NL02',
                        name: 'Rotterdam',
                        parent: 'NL',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Netherlands/',
                        children: [],
                        emiCode: 9898984289452
                    }
                ],
                emiCode: 781830124650
            },
            {
                code: 'NO',
                name: 'Norway',
                parent: '1A',
                isSelected: false,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'NO',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'NO01',
                        name: 'Oslo',
                        parent: 'NO',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Norway/',
                        children: [],
                        emiCode: 7461045608007
                    }
                ],
                emiCode: 4466833475567
            },
            {
                code: 'PT',
                name: 'Portugal',
                parent: '1A',
                isSelected: false,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'PT',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'PT01',
                        name: 'Lisbon',
                        parent: 'PT',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Portugal/',
                        children: [],
                        emiCode: 9613542895842
                    }
                ],
                emiCode: 69988726530
            },
            {
                code: 'ES',
                name: 'Spain',
                parent: '1A',
                isSelected: false,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'ES',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'ES02',
                        name: 'Barcelona',
                        parent: 'ES',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Spain/',
                        children: [],
                        emiCode: 6684446699691
                    },
                    {
                        code: 'ES01',
                        name: 'Madrid',
                        parent: 'ES',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Spain/',
                        children: [],
                        emiCode: 8755824977500
                    }
                ],
                emiCode: 756515136679
            },
            {
                code: 'SE',
                name: 'Sweden',
                parent: '1A',
                isSelected: false,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'SE',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'SE02',
                        name: 'Gothenburg',
                        parent: 'SE',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Sweden/',
                        children: [],
                        emiCode: 417790364101
                    },
                    {
                        code: 'SE01',
                        name: 'Stockholm',
                        parent: 'SE',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Sweden/',
                        children: [],
                        emiCode: 560498367886
                    }
                ],
                emiCode: 1213577185562
            },
            {
                code: 'CH',
                name: 'Switzerland',
                parent: '1A',
                isSelected: false,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'CH',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'CH02',
                        name: 'Geneva',
                        parent: 'CH',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Switzerland/',
                        children: [],
                        emiCode: 475875052745
                    },
                    {
                        code: 'CH01',
                        name: 'Zurich',
                        parent: 'CH',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Switzerland/',
                        children: [],
                        emiCode: 8508324897347
                    }
                ],
                emiCode: 9340000059197
            },
            {
                code: 'TR',
                name: 'Turkey',
                parent: '1A',
                isSelected: false,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'TR',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'TR02',
                        name: 'Ankara',
                        parent: 'TR',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Turkey/',
                        children: [],
                        emiCode: 2211888300000
                    },
                    {
                        code: 'TR01',
                        name: 'Istanbul',
                        parent: 'TR',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Turkey/',
                        children: [],
                        emiCode: 2209633005746
                    }
                ],
                emiCode: 5108079124379
            },
            {
                code: 'GB',
                name: 'United Kingdom',
                parent: '1A',
                isSelected: false,
                typeId: 5,
                tierId: 1,
                menuOptions: [
                    {
                        nodeCode: 'GB',
                        tierId: 5,
                        typeId: 15,
                        tierName: 'Cities',
                        countryName: 'Cities',
                        isSelected: false,
                        title: 'Select all  Cities'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'GB04',
                        name: 'Birmingham',
                        parent: 'GB',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ United Kingdom/',
                        children: [],
                        emiCode: 4679059978447
                    },
                    {
                        code: 'GB01',
                        name: 'Glasgow',
                        parent: 'GB',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ United Kingdom/',
                        children: [],
                        emiCode: 6060475542198
                    },
                    {
                        code: 'GB02',
                        name: 'Leeds',
                        parent: 'GB',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ United Kingdom/',
                        children: [],
                        emiCode: 4815718641720
                    },
                    {
                        code: 'GB03',
                        name: 'London',
                        parent: 'GB',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ United Kingdom/',
                        children: [],
                        emiCode: 6701003666501
                    },
                    {
                        code: 'GB05',
                        name: 'Manchester',
                        parent: 'GB',
                        isSelected: false,
                        typeId: 15,
                        tierId: 5,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ United Kingdom/',
                        children: [],
                        emiCode: 9885597442368
                    }
                ],
                emiCode: 6892985927316
            },
            {
                code: '1B',
                name: 'Other Western Europe',
                parent: '1A',
                isSelected: false,
                typeId: 3,
                tierId: 0,
                menuOptions: [
                    {
                        nodeCode: '1B',
                        tierId: 0,
                        typeId: 0,
                        tierName: 'Countries',
                        countryName: 'Countries',
                        isSelected: true,
                        title: 'Deselect all Countries'
                    },
                    {
                        nodeCode: '1B',
                        tierId: 4,
                        typeId: 6,
                        tierName: 'Modelled country',
                        countryName: 'Modelled country',
                        isSelected: false,
                        title: 'Select all  Modelled country'
                    },
                    {
                        nodeCode: '1B',
                        tierId: 2,
                        typeId: 37,
                        tierName: 'Market Insight (Research)',
                        countryName: 'Market Insight (Research)',
                        isSelected: false,
                        title: 'Select all  Market Insight (Research)'
                    }
                ],
                hierarchy: 'World/ Western Europe/',
                children: [
                    {
                        code: 'RR',
                        name: 'Andorra',
                        parent: '1B',
                        isSelected: false,
                        typeId: 6,
                        tierId: 4,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Other Western Europe/',
                        children: [],
                        emiCode: 1972541788296
                    },
                    {
                        code: 'CY',
                        name: 'Cyprus',
                        parent: '1B',
                        isSelected: false,
                        typeId: 37,
                        tierId: 2,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Other Western Europe/',
                        children: [],
                        emiCode: 9208763750029
                    },
                    {
                        code: 'GI',
                        name: 'Gibraltar',
                        parent: '1B',
                        isSelected: false,
                        typeId: 6,
                        tierId: 4,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Other Western Europe/',
                        children: [],
                        emiCode: 5609336301431
                    },
                    {
                        code: 'IC',
                        name: 'Iceland',
                        parent: '1B',
                        isSelected: false,
                        typeId: 37,
                        tierId: 2,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Other Western Europe/',
                        children: [],
                        emiCode: 4132939641899
                    },
                    {
                        code: 'LI',
                        name: 'Liechtenstein',
                        parent: '1B',
                        isSelected: false,
                        typeId: 6,
                        tierId: 4,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Other Western Europe/',
                        children: [],
                        emiCode: 4274424962792
                    },
                    {
                        code: 'LX',
                        name: 'Luxembourg',
                        parent: '1B',
                        isSelected: false,
                        typeId: 6,
                        tierId: 4,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Other Western Europe/',
                        children: [],
                        emiCode: 4726089818243
                    },
                    {
                        code: 'MT',
                        name: 'Malta',
                        parent: '1B',
                        isSelected: false,
                        typeId: 37,
                        tierId: 2,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Other Western Europe/',
                        children: [],
                        emiCode: 4224690765674
                    },
                    {
                        code: 'MN',
                        name: 'Monaco',
                        parent: '1B',
                        isSelected: false,
                        typeId: 6,
                        tierId: 4,
                        menuOptions: [],
                        hierarchy: 'World/ Western Europe/ Other Western Europe/',
                        children: [],
                        emiCode: 2675745862757
                    }
                ],
                emiCode: 2066083413038
            }
        ],
        emiCode: 8420189753846
    }
};
